






























import AppraisalForm from "@/components/appraisal/AppraisalForm.vue";
import CompanySheet from "@/components/company/CompanySheet.vue";
import DropAreaMulti from "@/components/files/DropAreaMulti.vue";
import LineItemsForm from "@/components/repair-estimate/LineItemsForm.vue";
import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import MNoContent from "@/components/utility/mmmint/MNoContent.vue";
import { CurrencyEnum } from "@/lib/enum/currency.enum";
import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import { TotalLossType } from "@/lib/enum/total-loss-type.enum";
import { IDialog } from "@/lib/interfaces/dialog.interface";
import { formatCurrency } from "@/lib/utility/currency-helper";
import { getAutocompleteFilter } from "@/lib/utility/filter";
import { handleError } from "@/lib/utility/handleError";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { Appraisal, IAppraisal } from "@/models/appraisal.entity";
import { Reference } from "@/models/reference.entity";
import { SignDocument } from "@/models/sign-document.entity";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { UserModule } from "@/store/modules/me-user.store";
import { PartnerModule } from "@/store/modules/partner";
import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component({
  components: { CompanySheet, MNoContent, LineItemsForm, DropAreaMulti, AppraisalForm, ConfirmActionDialog },
  filters: {}
})
export default class PartnerReportAppraisalUpdateDialog extends mixins(PermissionMixin, RulesMixin) implements IDialog {
  @Prop({ default: false }) value!: boolean;
  @Prop() appraisal!: IAppraisal;
  readonly getAutocompleteFilter = getAutocompleteFilter;
  readonly formatCurrency = formatCurrency;
  readonly CurrencyEnum = CurrencyEnum;
  readonly TotalLossType = TotalLossType;
  dialog: boolean = this.value;
  localAppraisal?: IAppraisal | null = null;
  requestsLoading = false;
  file: File | null = null;
  isValid = false;

  get files(): File[] {
    if (this.file) {
      return [this.file];
    }
    return [];
  }

  set files(files: File[]) {
    if (files.length > 0) {
      this.file = files[0];
    } else {
      this.file = null;
    }
  }

  get partner() {
    return PartnerModule.partner;
  }

  get context() {
    return {
      appraisal: this.localAppraisal,
      partner: this.partner
    };
  }

  get validForm() {
    return this.isValid;
  }

  get myUserId() {
    return UserModule.userId;
  }

  @Watch("value")
  onValueChange(val: boolean) {
    if (val) {
      this.reset();
    }
    this.localAppraisal = new Appraisal(this.appraisal);
    this.dialog = val;
  }

  @Watch("dialog")
  onDialogChange(val: boolean) {
    this.$emit("input", val);
  }

  @Watch("file")
  setEstimateNumber() {
    if (!this.localAppraisal) return;

    if (!this.localAppraisal.title && this.file) {
      if (this.file.name?.endsWith(".pdf")) {
        this.localAppraisal.title = this.file.name.substring(0, this.file.name.length - 4);

        return;
      }
      this.localAppraisal.title = this.file.name;

      return;
    }
  }

  open() {
    this.dialog = true;
  }

  close() {
    this.dialog = false;
  }

  reset() {
    this.file = null;
    this.localAppraisal = null;
  }

  async update() {
    if (!this.localAppraisal) return;
    this.requestsLoading = true;

    try {
      const refs = [];

      const appraisal = await this.localAppraisal.update();

      if (this.appraisal.reportId) {
        refs.push(new Reference({ refId: this.appraisal.reportId, refType: ResourceEnum.REPORT }));
      }

      refs.push(new Reference({ refId: appraisal.id, refType: ResourceEnum.APPRAISAL }));

      if (this.file) {
        const signDocument = new SignDocument({
          name: this.file.name,
          title: this.file.name,
          isTemplate: false,
          folder: "/appraisal/",
          refs: refs,
          file: this.file,
          partnerId: this.partner.id
        });

        await signDocument.create();

        await this.localAppraisal.updatePartial({
          documentId: signDocument.id,
          status: RequestStatusEnum.REPLIED
        });
        this.localAppraisal.document = signDocument;
      }

      this.$emit("update:appraisal", this.localAppraisal);
      this.close();
    } catch (e) {
      handleError(e);
    } finally {
      this.requestsLoading = false;
    }

    return {
      appraisal: this.localAppraisal
    };
  }
}
